import React, { useState } from "react";
import axios from "axios";
import "./CreateNews.css"; // Importamos el CSS separado
import { subirNoticias } from "./constants";
import { useNavigate } from "react-router-dom";

const obtenerFechaActual = () => {
  const fechaActual = new Date();
  const desfaseHorario = fechaActual.getTimezoneOffset() * 60000;
  return new Date(fechaActual.getTime() - desfaseHorario)
    .toISOString()
    .split("T")[0];
};

const CreateNews = () => {
  const [titulo, setTitulo] = useState("");
  const [contenido, setContenido] = useState("");
  const [imagen, setImagen] = useState(null);
  const [fechaExpiracion, setFechaExpiracion] = useState("");
  const [url, setUrl] = useState(""); // 📌 Nuevo campo para la URL
  const navigate = useNavigate();
  const fechaMinima = obtenerFechaActual();

  const handleRegresarButton = () => {
    navigate("/admin-home");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const camposFaltantes = [];

    if (!titulo.trim()) camposFaltantes.push("Título");
    if (!contenido.trim()) camposFaltantes.push("Contenido");
    if (!imagen) camposFaltantes.push("Imagen");
    if (!fechaExpiracion) camposFaltantes.push("Fecha de vencimiento");
    if (!url.trim()) camposFaltantes.push("Enlace externo");

    if (camposFaltantes.length > 0) {
      alert(`Falta completar: ${camposFaltantes.join(", ")}.`);
      return;
    }

    if (fechaExpiracion < fechaMinima) {
      alert("La fecha de vencimiento no puede ser anterior a la fecha de hoy.");
      return;
    }

    if (!/^https?:\/\//i.test(url.trim())) {
      alert("Ingresa una URL válida (debe comenzar con http:// o https://).");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("titulo", titulo);
      formData.append("contenido", contenido);
      if (imagen) {
        formData.append("imagen", imagen);
      }
      formData.append("fecha_expiracion", fechaExpiracion);
      formData.append("url", url); // 📌 Se agrega la URL

      const response = await axios.post(subirNoticias, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Noticia creada:", response.data);
      alert("✅ Noticia creada exitosamente");

      // Limpiar el formulario
      setTitulo("");
      setContenido("");
      setImagen(null);
      setFechaExpiracion("");
      setUrl(""); // 📌 Limpiar el campo de URL
    } catch (error) {
      console.error("❌ Error al crear la noticia:", error);
      alert("❌ Ocurrió un error al crear la noticia");
    }
  };

  return (
    <div className="create-news-container">
      <h2>📰 Crear Nueva Noticia</h2>
      <form onSubmit={handleSubmit} className="create-news-form" noValidate>
        <div className="create-news-field">
          <label htmlFor="titulo">Título:</label>
          <input
            type="text"
            id="titulo"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
            required
          />
        </div>

        <div className="create-news-field">
          <label htmlFor="contenido">Contenido:</label>
          <textarea
            id="contenido"
            value={contenido}
            onChange={(e) => setContenido(e.target.value)}
            required
          />
        </div>

        <div className="create-news-field">
          <label htmlFor="imagen">Imagen:</label>
          <input
            type="file"
            id="imagen"
            accept="image/*"
            onChange={(e) => setImagen(e.target.files[0])}
            required
          />
        </div>

        <div className="create-news-field">
          <label htmlFor="fecha_expiracion">Fecha de Vencimiento:</label>
          <input
            type="date"
            id="fecha_expiracion"
            value={fechaExpiracion}
            min={fechaMinima}
            onChange={(e) => setFechaExpiracion(e.target.value)}
            required
          />
        </div>

        <div className="create-news-field">
          <label htmlFor="url">🔗 Enlace Externo:</label>
          <input
            type="url"
            id="url"
            placeholder="https://ejemplo.com"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="create-news-button">
          📤 Crear Noticia
        </button>
      </form>
      <div className="return-home">
        <span onClick={handleRegresarButton}>⬅️ Regresar a Inicio</span>
      </div>
    </div>
  );
};

export default CreateNews;
